<template>
  <div class="view">
    <v-container>
      <v-row>
        <v-col>
          <v-text-field

              label="Username"
              v-model="$store.state.$user.username"
              required
              outlined
              class="login-input"
              placeholder=""
          >
          </v-text-field>
          <v-text-field

              label="ชื่อ สกุล"
              v-model="$store.state.$user.name"

              outlined
              class="login-input"
              placeholder=""
          >
          </v-text-field>
          <v-text-field

              label="ชื่อเล่น"
              v-model="$store.state.$user.nickname"
              required
              outlined
              class="login-input"
              placeholder=""
          >
          </v-text-field>
          <v-text-field
              :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"

              :type="show_password ? 'text' : 'password'"
              outlined
              label="Password"
              hint="At least 8 characters"
              v-model="password1"
              class="input-group--focused"
              @click:append="show_password = !show_password"
          ></v-text-field>
          <v-text-field
              :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"

              :type="show_password ? 'text' : 'password'"
              outlined
              label="Confirm password"
              hint="At least 8 characters"
              v-model="password2"
              class="input-group--focused"
              @click:append="show_password = !show_password"
          ></v-text-field>


          <v-text-field

              label="รหัสพนักงาน"
              v-model="$store.state.$user.employee_code"

              outlined
              class="login-input"
              placeholder=""
              readonly
          >
          </v-text-field>
          <v-select
              :items="[{text:'PJ',value:'PJ'},{text:'MT',value:'MT'},{text:'TT',value:'TT'},{text:'OL',value:'OL'},{text:'FT',value:'FT'},{text:'HM',value:'HM'},{text:'Account',value:'AC'},{text:'Admin',value:'AD'},{text:'Other',value:'OT'},{text:'Logistic',value:'LG'}]"
              label="แผนก"
              v-model="$store.state.$user.department"
              outlined
              readonly
          ></v-select>

        </v-col>
        <v-col>


          <v-switch v-model="$store.state.$user.theme" @change="changeDarkMode($store.state.$user.theme)" class="ma-2"
                    label="Dark mode"></v-switch>


          <v-img
              width="128"
              v-if="$store.state.$user && $store.state.$user.picture"
              :src="$store.state.$user.picture"
              aspect-ratio="1"
              class="grey lighten-2"
          >
            <template v-slot:placeholder>
              <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
              >
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <v-file-input
              accept="image/png, image/jpeg, image/bmp"
              placeholder="กดเพื่อเปลี่ยนภาพโปรไฟล์"
              prepend-icon="mdi-camera"
              label="Avatar"
              @change="onFilePicked"
          ></v-file-input>


          <v-img
              width="300"
              v-if="$store.state.$user && $store.state.$user.signature"
              :src="$store.state.$user.signature"
              class="grey lighten-2"
          >
          </v-img>
          <v-file-input
              accept="image/png, image/jpeg, image/bmp"
              placeholder="กดเพื่อเปลี่ยนภาพลายเซ็น"
              prepend-icon="mdi-camera"
              label="Signature"
              @change="onSignaturePicked"
          ></v-file-input>
          Link LINE account (สแกนหรือกดคลิ๊กที่ QR)<br/>
          <a :href="line_login_url" target="_blank" style="margin-top: 12px;display: inline-block;"><qrcode-vue :value="line_login_url" :size="200" level="H"/></a>
<!--          Link LINE friend (สแกนหรือกดคลิ๊กที่ QR)<br/>-->
<!--          <a :href="line_friend_url" target="_blank" style="margin-top: 12px;display: inline-block;"><qrcode-vue :value="line_friend_url" :size="200" level="H"/></a>-->

        </v-col>
      </v-row>
      <v-row>
        <v-col class="col-10">
          <v-btn right @click="logout()">Logout</v-btn>
          <v-btn v-if="$store.state.$user.role===1" class="ml-8 primary" right :to="'/admin'">Admin</v-btn>

        </v-col>
        <v-col class="text-right col-2">
          <v-btn class="primary" :loading="isSave" @click="save()">Save</v-btn>
        </v-col>
      </v-row>

    </v-container>

    <v-snackbar
        v-model="snackbar"
        bottom
        :color="snackbar_color"
        :timeout="2000"
    >
      {{ snackbar_text }}
      <v-btn
          text
          @click="snackbar = false"
      >
        ปิด
      </v-btn>
    </v-snackbar>
  </div>
</template>
<style lang="scss" scoped>

.view {
  font-size: 18px;
}

.test1 {
  color: var(--v-secondary-darken1);
  background: var(--v-secondary-lighten1);
}

.test2 {
  color: var(--v-secondary-darken2);
  background: var(--v-secondary-lighten2);
}

.test3 {
  color: var(--v-secondary-darken3);
  background: var(--v-secondary-lighten3);
}

.test4 {
  color: var(--v-secondary-darken4);
  background: var(--v-secondary-lighten4);
}

.test5 {
  color: var(--v-secondary-darken5);
  background: var(--v-secondary-lighten5);
}

</style>
<script lang="ts">

import {Component, Vue} from 'vue-property-decorator'
import LoadingDummy from '../components/LoadingDummy.vue'
import {User} from '../models/User'
import router from '../router'
import Helper from '../services/Helper.js'
import QrcodeVue from 'qrcode.vue'

@Component({
  components: {LoadingDummy, QrcodeVue}
})
export default class ViewProfile extends Vue {

  show_password = false
  isSave = false
  snackbar = false
  snackbar_text = ''
  snackbar_color = ''
  password1 = ''
  password2 = ''

  line_login_url = ''
  line_friend_url = ''
  changeDarkMode(dark: boolean) {
    this.$vuetify.theme.dark = dark
  }

  changeTheme() {

  }

  changeProfile() {

  }

  onFilePicked(e) {
    const fr = new FileReader()
    fr.readAsDataURL(e)
    fr.addEventListener('load', () => {
      this.$store.state.$user.picture = fr.result
      // debugger
    })
  }

  onSignaturePicked(e) {
    const fr = new FileReader()
    fr.readAsDataURL(e)
    fr.addEventListener('load', () => {
      this.$store.state.$user.signature = fr.result
      // debugger
    })
  }

  async save() {
    if (this.password1 != this.password2) {
      this.snackbar_text = 'รหัสผ่านไม่ตรงกัน'
      this.snackbar_color = 'red'
      this.snackbar = true
      return
    }


    this.isSave = true
    let user: User = this.$store.state.$user
    if (!user.hasOwnProperty('save')) {
      user = Object.setPrototypeOf(user, User.prototype)
    }
    try {
      if (this.password1) {
        user.password = this.password1
      }


      await user.save<User>()
      this.snackbar_text = 'บันทึกสำเร็จ'
      this.snackbar_color = 'green'
    } catch (e) {
      this.snackbar_text = e.toString()
      this.snackbar_color = 'red'
    }
    this.snackbar = true
    this.isSave = false
  }

  async mounted() {

    Helper.get('/api/me')
        .then(({data}) => {
          this.line_login_url = data.data.line_login_url
          this.line_friend_url = data.data.line_friend_url
        })
        .catch(() => {
          // setTimeout(() => {this.getMe()}, 20000)
        })
  }

  logout() {
    Helper.logOut()
    router.push('/login')
  }
}
</script>
